(function () {
    'use strict';

    angular.module('app.spares', ['smart-table', 'treeControl', 'ui.bootstrap', 'ui.grid', 'ui.grid.pagination']);
})();